import { Reducer, UnknownAction } from 'redux';

/**
 * Works like redux.combineReducers, but does not affect other properties on root level like `texts`
 *
 * @param reducers An object whose values correspond to different reducer functions that need to be combined into one
 */
export const mergeReducers = <T extends object>(reducers: { [K in keyof T]: Reducer<T[K]> }): Reducer<T> =>
  (state: T, action: UnknownAction) =>
    Object.keys(reducers).reduce((currentRootState: object, key) => {
      const previousBranchState = (!!state && state[key]) || undefined;
      const currentBranchState = reducers[key](previousBranchState, action);
      return currentBranchState === previousBranchState
        ? currentRootState
        : {
          ...currentRootState,
          [key]: currentBranchState
        };
    }, state) as T;
